import {detectBreakpoint} from "../../../../../utilities/sal-breakpoint/sal-breakpoint"
import Vue from 'vue'
import Vuex, {Store} from 'vuex'
import type { ActionTree } from "vuex"
import type {SolutionGuide} from "../../../../../_types/solutionguide"
import type {Productfinder} from "../../../../../_types/productfinder";
import solutionGuideGetters from "./solutionGuideGetters";
import solutionGuideMutations from "./solutionGuideMutations";

Vue.use(Vuex)

export enum STEP {
    Application = "application",
    Component = "component",
    Property = "property",
    Decor = "decor",
    Result = "result"
}

export class State {
    // Rahmenbedingungen
    activeBreakpoint = detectBreakpoint()

    //Prozess
    activeStep: STEP = STEP.Application

    // Selection
    segment: SolutionGuide.Segment | null = null
    application: SolutionGuide.Application | null = null
    component: SolutionGuide.Component | null = null
    properties: string[] = []
    decor: Productfinder.Product | null = null
    result: SolutionGuide.DekorativePlatte | null = null

    ctalink: SolutionGuide.Typolink | null = null

    selectedDecors: {
        [key: string]: Productfinder.Product
    } = {}
}

const actions = <ActionTree<State, unknown>>{
    updateViewport(store) {
        store.commit('_updateViewport', detectBreakpoint())
    },
    backToStep(store, targetStep) {
        // Call 'back' as many times as needed to go back to the rquested step or the beginning
        while (store.getters.isPreviousStep(targetStep)) {
            store.commit('back')
        }
    },
    restart(store) {
        store.dispatch('backToStep', STEP.Application)
    }
}

export default new Store({
    state: new State(),
    mutations: solutionGuideMutations,
    actions: actions,
    getters: solutionGuideGetters
})
